/** How far Shift+arrow moves the playhead, in seconds. */
export const seekStepSeconds = 10;

/**
 * Where a relative seek lands: never before the start, and never onto the
 * very end - a seek that lands on the end fires `ended` and skips to the
 * next track, which is not what a key that means "a bit forward" should do.
 * An unknown duration (NaN, Infinity, 0) only clamps at the start.
 */
export function seekTarget(currentSeconds: number, deltaSeconds: number, durationSeconds: number) {
  const target = Math.max(0, currentSeconds + deltaSeconds);

  if (!(durationSeconds > 0) || !isFinite(durationSeconds)) {
    return target;
  }

  return Math.min(target, Math.max(0, durationSeconds - 1));
}
